// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .NoItem-panelSpace-Ne7AT {
 	padding-right: 20px;
 }

 .NoItem-panelEmpty-FMvy2 {
 	border-radius: 0;
 	width: 100%;
 	display: block;
 	font-size: 14px;
 	line-height: 1.43;
 	color: var(--common-text-color);
 }

 .NoItem-nolistTitle-dLJXY {
 	font-size: 16px;
 	font-weight: bold;
 	color: var(--common-text-color);
 }

 .NoItem-noResults-R4TvU {
 	font-size: 14px;
 	font-weight: normal;
 	color: var(--common-text-color);
 }

 .NoItem-textCenter-h3zgP {
 	text-align: center;
 }

 .NoItem-button-oG7ZD {
 	border-color: var(--btn-primary-bg-hover);
 	background-color: var(--btn-primary-bg-hover);
 	color: var(--white-text);
 	font-size: 14px;
 	font-weight: bold;
 }

 .NoItem-button-oG7ZD:hover {
 	background: rgba(54, 50, 119, 0.8);
 }

 .NoItem-button-oG7ZD:focus {
 	border-color: #0074c2;
 	-webkit-box-shadow: 0 0 8px rgba(0, 116, 194, 0.6);
 	        box-shadow: 0 0 8px rgba(0, 116, 194, 0.6);
 }

 .NoItem-btnPrimary-Minnr {
 	border-color: var(--btn-primary-bg);
 	background-color: var(--btn-primary-bg);
 	color: var(--white-text);
 	border-radius: 60px;
 }

 .NoItem-btnPrimary-Minnr:hover,
 .NoItem-btnPrimary-Minnr:focus,
 .NoItem-btnPrimary-Minnr:active,
 .NoItem-btnPrimary-Minnr:active:hover,
 .NoItem-btnPrimary-Minnr:active:focus {
 	border-color: var(--btn-primary-bg-hover);
 	background-color: var(--btn-primary-bg-hover);
 	color: var(--white-text);
 }

 .NoItem-btnPrimaryBorder-RTAUO {
 	border-color: var(--btn-primary-bg);
 	color: var(--btn-primary-bg);
 	background-color: var(--primary-white-bg);
 }

 .NoItem-btnPrimaryBorder-RTAUO:hover,
 .NoItem-btnPrimaryBorder-RTAUO:focus,
 .NoItem-btnPrimaryBorder-RTAUO:active,
 .NoItem-btnPrimaryBorder-RTAUO:active:hover,
 .NoItem-btnPrimaryBorder-RTAUO:active:focus {
 	border-color: var(--btn-primary-bg-hover);
 	color: var(--btn-primary-bg-hover);
 	background-color: var(--primary-white-bg);
 }

 .NoItem-space3-Qfglb {
 	margin-bottom: 18px;
 }

 .NoItem-space4-Zg0SQ {
 	margin-bottom: 24px;
 }

 .NoItem-spaceTop4-cyr_S {
 	margin-top: 24px;
 }

 .NoItem-spaceTop2-Y1Asi {
 	margin-top: 12px;
 }

 .NoItem-space1-AG87z {
 	margin-bottom: 6px
 }

 .NoItem-space2-kGU9a {
 	margin-bottom: 12px;
 }

 .NoItem-noPadding-tjsx4 {
 	padding: 0px;
 }

 .NoItem-top-i5YQl {
 	margin-top: 65px;
 }`, "",{"version":3,"sources":["webpack://./src/components/Reservation/NoItem/NoItem.css"],"names":[],"mappings":"CAAC;EACC,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,+BAA+B;CAChC;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,+BAA+B;CAChC;;CAEA;EACC,eAAe;EACf,mBAAmB;EACnB,+BAA+B;CAChC;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,yCAAyC;EACzC,6CAA6C;EAC7C,wBAAwB;EACxB,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,kCAAkC;CACnC;;CAEA;EACC,qBAAqB;EACrB,kDAA0C;UAA1C,0CAA0C;CAC3C;;CAEA;EACC,mCAAmC;EACnC,uCAAuC;EACvC,wBAAwB;EACxB,mBAAmB;CACpB;;CAGA;;;;;EAKC,yCAAyC;EACzC,6CAA6C;EAC7C,wBAAwB;CACzB;;CAEA;EACC,mCAAmC;EACnC,4BAA4B;EAC5B,yCAAyC;CAC1C;;CAEA;;;;;EAKC,yCAAyC;EACzC,kCAAkC;EAClC,yCAAyC;CAC1C;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC;CACD;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,YAAY;CACb;;CAEA;EACC,gBAAgB;CACjB","sourcesContent":[" .panelSpace {\n \tpadding-right: 20px;\n }\n\n .panelEmpty {\n \tborder-radius: 0;\n \twidth: 100%;\n \tdisplay: block;\n \tfont-size: 14px;\n \tline-height: 1.43;\n \tcolor: var(--common-text-color);\n }\n\n .nolistTitle {\n \tfont-size: 16px;\n \tfont-weight: bold;\n \tcolor: var(--common-text-color);\n }\n\n .noResults {\n \tfont-size: 14px;\n \tfont-weight: normal;\n \tcolor: var(--common-text-color);\n }\n\n .textCenter {\n \ttext-align: center;\n }\n\n .button {\n \tborder-color: var(--btn-primary-bg-hover);\n \tbackground-color: var(--btn-primary-bg-hover);\n \tcolor: var(--white-text);\n \tfont-size: 14px;\n \tfont-weight: bold;\n }\n\n .button:hover {\n \tbackground: rgba(54, 50, 119, 0.8);\n }\n\n .button:focus {\n \tborder-color: #0074c2;\n \tbox-shadow: 0 0 8px rgba(0, 116, 194, 0.6);\n }\n\n .btnPrimary {\n \tborder-color: var(--btn-primary-bg);\n \tbackground-color: var(--btn-primary-bg);\n \tcolor: var(--white-text);\n \tborder-radius: 60px;\n }\n\n\n .btnPrimary:hover,\n .btnPrimary:focus,\n .btnPrimary:active,\n .btnPrimary:active:hover,\n .btnPrimary:active:focus {\n \tborder-color: var(--btn-primary-bg-hover);\n \tbackground-color: var(--btn-primary-bg-hover);\n \tcolor: var(--white-text);\n }\n\n .btnPrimaryBorder {\n \tborder-color: var(--btn-primary-bg);\n \tcolor: var(--btn-primary-bg);\n \tbackground-color: var(--primary-white-bg);\n }\n\n .btnPrimaryBorder:hover,\n .btnPrimaryBorder:focus,\n .btnPrimaryBorder:active,\n .btnPrimaryBorder:active:hover,\n .btnPrimaryBorder:active:focus {\n \tborder-color: var(--btn-primary-bg-hover);\n \tcolor: var(--btn-primary-bg-hover);\n \tbackground-color: var(--primary-white-bg);\n }\n\n .space3 {\n \tmargin-bottom: 18px;\n }\n\n .space4 {\n \tmargin-bottom: 24px;\n }\n\n .spaceTop4 {\n \tmargin-top: 24px;\n }\n\n .spaceTop2 {\n \tmargin-top: 12px;\n }\n\n .space1 {\n \tmargin-bottom: 6px\n }\n\n .space2 {\n \tmargin-bottom: 12px;\n }\n\n .noPadding {\n \tpadding: 0px;\n }\n\n .top {\n \tmargin-top: 65px;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelSpace": `NoItem-panelSpace-Ne7AT`,
	"panelEmpty": `NoItem-panelEmpty-FMvy2`,
	"nolistTitle": `NoItem-nolistTitle-dLJXY`,
	"noResults": `NoItem-noResults-R4TvU`,
	"textCenter": `NoItem-textCenter-h3zgP`,
	"button": `NoItem-button-oG7ZD`,
	"btnPrimary": `NoItem-btnPrimary-Minnr`,
	"btnPrimaryBorder": `NoItem-btnPrimaryBorder-RTAUO`,
	"space3": `NoItem-space3-Qfglb`,
	"space4": `NoItem-space4-Zg0SQ`,
	"spaceTop4": `NoItem-spaceTop4-cyr_S`,
	"spaceTop2": `NoItem-spaceTop2-Y1Asi`,
	"space1": `NoItem-space1-AG87z`,
	"space2": `NoItem-space2-kGU9a`,
	"noPadding": `NoItem-noPadding-tjsx4`,
	"top": `NoItem-top-i5YQl`
};
module.exports = ___CSS_LOADER_EXPORT___;
